<template>
  <div>
    <div v-if="!!predominantSymptom">
      <field-label label="Sintoma predominante" class="mb-4" titleColorClass="grey--text text--darken-2">
        <span class="text-h6">{{ predominantSymptom === 'AXIAL' ? 'ASAS Axial' : 'ASAS Periférico' }}</span>
      </field-label>

      <text-area :value="attendanceHypothesis" auto-grow readonly hide-details class="hypothesis" />

      <div class="d-flex flex-column grey--text text--darken-1 font-weight-bold mt-6">
        <p>
          Esse fluxo foi criado para auxiliar na avaliação e conduta de casos com suspeita de espondiloartrites.
          Utilizamos o critério classificatório ASAS para essa análise e disponibilizamos outros SCORES para auxílio.
        </p>

        <p>
          Clique no menu à direita em <v-icon color="primary">mdi-human-greeting-proximity</v-icon> (INTERCONSULTA) para
          discutir o seu caso com um EXPERT.
        </p>
      </div>
    </div>
    <div v-else>
      <h2>É necessário definir um sintoma predominante na aba Anamnese &gt; Sintomas</h2>
    </div>
  </div>
</template>

<script>
import BasePhase from '@/components/AttendanceForm/general/phase/BasePhase.vue'
import TextArea from '@/components/TextArea.vue'
import FieldLabel from '@/components/FieldLabel.vue'

import { createNamespacedHelpers } from 'vuex'
const { mapGetters: attendanceGettersMap } = createNamespacedHelpers('attendance')

export default {
  extends: BasePhase,
  components: {
    FieldLabel,
    TextArea,
  },
  computed: {
    ...attendanceGettersMap(['attendanceHypothesis', 'getPhaseDataByKey']),
    predominantSymptom() {
      return this.getPhaseDataByKey('sintomas')?.predominantSymptom
    },
  },
  methods: {
    getDefaultData() {
      return null
    },
  },
}
</script>

<style scoped></style>
